import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { useFlexActivationMessaging } from "../hooks/useFlexActivationMessaging";

export function useActivationReferralShareMessage(referralCode: string) {
  const { getReferralRequirementMessage } = useFlexActivationMessaging();
  const { messageTemplate } = useCbhFlag(CbhFeatureFlag.ACTIVATION_REFERRAL_SHARE_MESSAGE_CONFIG, {
    defaultValue: {
      messageTemplate: `Hey! I work through Clipboard, and I love it! Use my referral code {{referral_code}} when you sign up and you'll get a bonus after you ${getReferralRequirementMessage()}!`,
    },
  });

  return messageTemplate.replace("{{referral_code}}", referralCode);
}
